import SessionStorage from "sessionstorage";
import axios from "axios";
import {APIHOST, MOMENT_API_DATE_FORMAT} from "@/settings";
import PrintJs from "print-js";

class ReturnShipmentService {
    register(data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'))
        return axios.post(`${APIHOST}/api/RegisterReturnShipment`, data, {headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}})
    }

    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnShipmentInfo/${id}`, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getAllbox({
                  sortBy,
                  sortDesc,
                  skip,
                  limit,
                  order,
                  deliveryDate,
                  q,
                  branch,
                  date,
                  start,
                  end,
                  isExecutorApproved,
                  isCustomerApproved,
                  isDeclined,
                  hasInvoice,
                  status,
                  statuses
              }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnShipmentAllBox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                order: order ? order : null,
                deliveryDate: deliveryDate ? deliveryDate.toISOString(true) : null,
                q: typeof (q) === 'undefined' ? null : q,
                branch: typeof (branch) === 'undefined' ? null : branch,
                date: date ? date.format(MOMENT_API_DATE_FORMAT) : null,
                start: start ? start.format(MOMENT_API_DATE_FORMAT) : null,
                end: end ? end.format(MOMENT_API_DATE_FORMAT) : null,
                isExecutorApproved: typeof (isExecutorApproved) === 'boolean' ? isExecutorApproved : null,
                isCustomerApproved: typeof (isCustomerApproved) === 'boolean' ? isCustomerApproved : null,
                isDeclined: typeof (isDeclined) === 'boolean' ? isDeclined : null,
                hasInvoice: typeof (hasInvoice) === 'boolean' ? hasInvoice : null,
                status: typeof (status) === 'number' ? status : null,
                statuses:statuses
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    printPdf(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        const promise = axios.get(`${APIHOST}/api/ReturnShipmentPdf`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {id: id}
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            PrintJs(url);
        });

        return promise;
    }

    accept(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/AcceptReturnShipment/${id}`, {}, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    approve(id, comment) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ApproveReturnShipment/${id}`, {Comment: comment}, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    decline(id, reason, comment) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        const data = {
            Reason: reason,
            Comment: comment
        }

        return axios.put(`${APIHOST}/api/DeclineReturnShipment/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }
}

export default new ReturnShipmentService()